import React, { useEffect } from 'react';

import { Box, Button, Grid, Link, Typography, styled } from '@material-ui/core';

import MaintenanceIcon from '../../assets/img/maintenance_icon_orange.svg';
// import MaintenanceIcon from '../../assets/img/maintenance_icon.svg';
import WhatsappSrc from '../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../assets/img/whatsapp.png';
import { appConfig } from '../../config/app';
import { CustomEvents } from '../../constants/analytics.constant';
import useLogEventInAnalytics from '../../hooks/useLogAnalyticsEvent';

const MaintenanceButton = styled(Button)({
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 400,
});

const Maintenance = () => {
  const { logEvent } = useLogEventInAnalytics();

  useEffect(() => {
    logEvent(CustomEvents.IN_MAINTENANCE_MESSAGE);
  }, [logEvent]);

  return (
    <>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Box
            mt={12}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <img src={MaintenanceIcon} alt="maintenance"></img>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12} md={6}>
          <Box
            mt={4}
            mb={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column"
          >
            <Typography
              variant="h4"
              align="center"
              style={{ fontWeight: 500, fontSize: '24px' }}
            >
              ¡Estamos trabajando para mejorar nuestro servicio!
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Grid item xs={11} md={4}>
          <Box
            mb={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column"
          >
            <Typography
              variant="body1"
              align="center"
              style={{ color: '#768692', fontWeight: 400, fontSize: '18px' }}
            >
              Perdón por los inconvenientes. Por favor, contáctanos si tenés
              alguna duda o necesitás asistencia.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center" alignItems="center">
        <Grid item xs={12}>
          <Box m={1} display="flex" alignItems="center" justifyContent="center">
            <Link
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
            >
              <MaintenanceButton variant="outlined" fullWidth color="secondary">
                <img
                  src={WhatsappSrc}
                  alt="Whatsapp"
                  style={{ marginRight: '15px' }}
                />
                <Typography display="inline">
                  Comunicarme vía Whatsapp
                </Typography>
              </MaintenanceButton>
            </Link>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Link
            href={appConfig?.ASSISTANCE_PHONE_LINK}
            rel="noopener"
            target="_blank"
            type="tel"
          >
            <Box m={1}>
              <MaintenanceButton variant="text" color="secondary" fullWidth>
                Solicitar una asistencia telefónicamente
              </MaintenanceButton>
            </Box>
          </Link>
        </Grid>
      </Grid>
    </>
  );
};

export default Maintenance;
